(() => {
  if (window.cartRequestGuardInstalled) return;
  window.cartRequestGuardInstalled = true;

  const originalFetch = window.fetch.bind(window);
  const minimumRequestInterval = 750;
  const maxAttempts = 4;
  let queue = Promise.resolve();
  let lastRequestAt = 0;

  const wait = (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

  const isCartMutation = (input, init = {}) => {
    const method = (init.method || (input instanceof Request && input.method) || 'GET').toUpperCase();
    if (method !== 'POST') return false;

    const url = new URL(input instanceof Request ? input.url : input, window.location.origin);
    const path = url.pathname.replace(/\.js$/, '').replace(/\/$/, '');
    return /\/cart\/(add|change|update|clear)$/.test(path);
  };

  const getRetryDelay = (response, attempt) => {
    const retryAfter = parseFloat(response.headers.get('Retry-After'));
    if (Number.isFinite(retryAfter)) return retryAfter * 1000;
    return 1500 * (attempt + 1);
  };

  const errorResponse = (status) => new Response(JSON.stringify({
    status,
    errors: 'Le panier est temporairement indisponible. Veuillez réessayer.'
  }), {
    headers: { 'Content-Type': 'application/json' }
  });

  const send = async (input, init) => {
    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const waitTime = Math.max(0, lastRequestAt + minimumRequestInterval - Date.now());
      if (waitTime) await wait(waitTime);
      lastRequestAt = Date.now();

      const requestInput = input instanceof Request ? input.clone() : input;
      const response = await originalFetch(requestInput, init);
      if (response.status !== 429) return response;

      if (attempt < maxAttempts - 1) {
        await wait(getRetryDelay(response, attempt));
      }
    }

    return errorResponse(429);
  };

  window.fetch = (input, init) => {
    if (!isCartMutation(input, init)) return originalFetch(input, init);

    const request = queue.then(() => send(input, init));
    queue = request.then(() => undefined, () => undefined);
    return request.catch((error) => {
      console.error('Cart request failed.', error);
      return errorResponse(0);
    });
  };
})();
